'use strict';


import { Report } from './QAReport';
import { Objects } from '../threejs/Objects/Objects';
import { Buildings } from '../../settings';

export class ObjectsQA extends Report{
	constructor () {
		super('Viewpoints');
	}
	
	validate() {
		if (this.jsonReport.length) {
			this.showReport();
			return;
		}
		
		const languages = config.languages;
		
		Objects.elements.forEach(scope => {
			switch (scope.objectType) {
				case 'Text':
					languages.forEach(lang => {
						const value = scope.translations[lang];
						if (!value) {
							this.addError(scope.translations.en,`Invalid translation`,lang);
						}
					});
					break;
				case 'CSSLabel':
					languages.forEach(lang => {
						const value = scope.data.title[lang];
						if (!value) {
							this.addError(scope.data.title.en,`Invalid translation`,lang);
						}
					});
					break;
			}
		});
		
		Buildings.getBuildingsArray().forEach(building => {
			building.cylinderLabels.forEach(label => {
				languages.forEach(lang => {
					const value = label.data.title[lang];
					if (!value) {
						this.addError(label.data.title.en,`Invalid translation`,lang);
					}
				});
			});
		});
		
		this.normalize();
		this.showReport();
	}
	
	normalize () {
		if (!this.log.length) {
			this.jsonReport.push('OK');
		} else {
			this.log.forEach(errorData => this.jsonReport.push(`Label ${errorData.apt}: ${errorData.message}. Expected translation for ${errorData.expected} language.`));
		}
	}
	
}
